import React, { useEffect } from "react";
import { StyledProTip, StyledProTipTop, StyledProTipBottom, StyledProTipMiddle, StyledHand } from "./styles";
import SVG from 'react-inlinesvg';
import useCookieDismissable from "../../../../hooks/useCookieDismissable";
import Cookies from "universal-cookie";

type HandPosition = "left" | "right" | "up" | "up-right" | "none";

interface ProTipProps {
  header: string;
  content: string;
  handPoints: HandPosition;
  button: string;
  top: string;
  left: string;
  success?: () => void;
  id: string;
}

const ProTip = ({
  header,
  content,
  handPoints,
  button,
  top,
  left,
  success,
  id
}: ProTipProps) => {
  const [, dismiss] = useCookieDismissable(`tip_${id}`, 60 * 60 * 24 * 30) as [boolean, () => void];
  // replace THUMBS_UP in the content with an SVG element
  const contentWithSVG = content.replace("THUMBS_UP", `<img src="/assets/brainstorm/thumbs-up-white.svg"/>`).replace("THUMBS_DOWN", `<img src="/assets/brainstorm/thumbs-down-white.svg"/>`);
  const buttonWithSVG = button.replace("THUMBS_UP", `<img src="/assets/brainstorm/thumbs-up-white.svg"/>`);

  const cookies = new Cookies();
  const showTip = !cookies.get(`tip_${id}`);

  // Dismiss on Escape, but only if no other component already handled it
  useEffect(() => {
    if (!showTip) return;
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape" && !e.defaultPrevented) {
        dismiss();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [showTip, dismiss]);

  return (showTip && <StyledProTip top={top} left={left} key={id + '_tip'} aria-label={header}>
    <StyledHand position={handPoints}>
      {handPoints !== 'none' && <SVG src="/assets/brainstorm/hand.svg" />}
    </StyledHand>
    <StyledProTipTop>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </StyledProTipTop>
    <StyledProTipMiddle>
      <h3>{header}</h3>
      <div dangerouslySetInnerHTML={{ __html: contentWithSVG }} />
      <button className="bf-button" onClick={() => {
        success?.();
        dismiss();
      }} dangerouslySetInnerHTML={{ __html: buttonWithSVG }} />
    </StyledProTipMiddle>
    <StyledProTipBottom>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </StyledProTipBottom>
  </StyledProTip>);
};

export default ProTip;
